export default __webpack_public_path__ + "static/media/greenTruckMobile.cf26c58c.jpg";